// extracted by mini-css-extract-plugin
var _1 = "PerksListContainer_plansPerksList__rCidW";
export { _1 as "plansPerksList" }
